
const getApiBaseUrl = () => {
  // Priority 1: REACT_APP_API_URL (Matches UserBase.jsx and FormulaRepository.jsx usage)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Priority 2: REACT_APP_API_BASE_URL (Matches userSlice.js and analysisActions.js usage)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Priority 3: Default to localhost for development
  return 'http://localhost:8000';
};

export const API_BASE_URL = getApiBaseUrl();
export const WS_BASE_URL = API_BASE_URL.replace(/^http/, 'ws');

// Diagnostic log to help debug URL issues in production environment
console.log("🚀 API Base URL initialized as:", API_BASE_URL);

/**
 * Helper to build full API URLs and log them for monitoring
 */
export const buildApiUrl = (path) => {
  const url = `${API_BASE_URL}${path.startsWith('/') ? path : '/' + path}`;
  // Only log in production or if explicitly enabled for easier monitoring
  if (process.env.NODE_ENV === 'production') {
    console.log(`📡 [API Request] Targeting: ${url}`);
  }
  return url;
};
